import styled from '@emotion/styled'
import { layout, space, color, typography, flexbox } from 'styled-system'

export default styled.div`
  ${({ centered }) =>
    centered
      ? `
          display: flex;
          justify-content: center;
          align-items: center;
        `
      : `
          display: flex;
          margin-right: 10px;
        `};

  ${layout};
  ${space};
  ${color};
  ${typography};
  ${flexbox};
`
